import { ZERO_ADDRESS } from '@/web3/constants'
import { Address } from 'viem'
import { NetworkId } from './network-details'
import POLYGON_MUMBAI_ADDRESSES from './contract-addresses/polygon-testnet'
import ARBITRUM_TESTNET_ADDRESSES from './contract-addresses/arbitrum-testnet'
import LOCAL_ADDRESSES from './contract-addresses/local'
import BLOCKPOT_TESTNET_ADDRESSES from './contract-addresses/blockpot-testnet'

export enum ContractName {
    LOTTERY_MAIN,
    BLOCK_POT_TOKEN,
    CONFIG_MANAGER,
    BLOCK_POT_REWARD_TRACKER,
    BLOCK_POT_REFERRAL_MANAGER,
    CHAINLINK_AGGREGATOR_V3,
    FUNDS_MANAGER_MAIN,
    CONTRIBUTORS_REWARD_TRACKER,
    QUICK_GAME,
    WETH
}

export function getContractAddress(chainId: number, contractName: ContractName): Address {
    switch (contractName) {
    case ContractName.LOTTERY_MAIN:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.lottery
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.lottery
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.lottery
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.lottery
        }
        break
    case ContractName.BLOCK_POT_TOKEN:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.blockPotToken
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.blockPotToken
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.blockPotToken
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.blockPotToken
        }
        break
    case ContractName.CONFIG_MANAGER:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.configManager
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.configManager
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.configManager
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.configManager
        }
        break
    case ContractName.BLOCK_POT_REWARD_TRACKER:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.rewardTracker
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.rewardTracker
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.rewardTracker
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.rewardTracker
        }
        break
    case ContractName.BLOCK_POT_REFERRAL_MANAGER:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.referralManager
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.referralManager
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.referralManager
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.referralManager
        }
        break
    case ContractName.CHAINLINK_AGGREGATOR_V3:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.aggregatorV3
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.aggregatorV3
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.aggregatorV3
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.aggregatorV3
        }
        break
    case ContractName.FUNDS_MANAGER_MAIN:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.fundsManager
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.fundsManager
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.fundsManager
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.fundsManager
        }
        break
    case ContractName.CONTRIBUTORS_REWARD_TRACKER:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.contributorsRewardTracker
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.contributorsRewardTracker
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.contributorsRewardTracker
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.contributorsRewardTracker
        }
        break
    case ContractName.QUICK_GAME:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.quickGame
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.quickGame
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.quickGame
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.quickGame
        }
        break
    case ContractName.WETH:
        switch (chainId) {
        case NetworkId.LOCAL: return LOCAL_ADDRESSES.weth
        case NetworkId.POLYGON_TESTNET: return POLYGON_MUMBAI_ADDRESSES.weth
        case NetworkId.ARBITRUM_TESTNET: return ARBITRUM_TESTNET_ADDRESSES.weth
        case NetworkId.BLOCK_POT_TESTNET: return BLOCKPOT_TESTNET_ADDRESSES.weth
        }
        break
    }
    console.error(`Failed to find contract address for chainId: ${chainId} and contractName: ${contractName}`)
    return ZERO_ADDRESS
}